// Centralized SEO Configuration for App Developer Pro

export const companyInfo = {
  name: "App Developer Pro",
  legalName: "App Developer Pro - Professional Mobile App & Web Application Development",
  description: "Leading app developer specializing in mobile app development, web applications, UI/UX design, e-commerce solutions, and digital marketing.",
  url: "https://appdeveloperpro.com",
  logo: "https://appdeveloperpro.com/images/team-at-work-app-developer-pro.jpg",
  image: "https://appdeveloperpro.com/images/web-development-services.png",
  foundingDate: "2020",
  
  // Contact Information (matches footer)
  contact: {
    phone: "(882) 636-0188",
    phoneInternational: "+91-882-636-0188",
    email: "hello@appdeveloperpro.com",
  },
  
  // Address Information (matches footer)
  address: {
    streetAddress: "827, Kachpura, Kundol",
    addressLocality: "Agra",
    addressRegion: "Uttar Pradesh",
    postalCode: "283111",
    addressCountry: "IN",
    fullAddress: "827, Kachpura, Kundol, Agra, Uttar Pradesh 283111"
  },
  
  // Social Media
  socialMedia: {
    facebook: "https://www.facebook.com/appdeveloperpro",
    twitter: "https://www.twitter.com/appdeveloperpro",
    linkedin: "https://www.linkedin.com/company/appdeveloperpro",
    instagram: "https://www.instagram.com/appdeveloperpro"
  },
  
  // Business Details
  priceRange: "$$",
  areaServed: "Global",
  serviceType: ["Web Development", "Mobile App Development", "UI/UX Design", "E-commerce Solutions", "Digital Marketing"],
};

// Organization Schema (used across all pages)
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": companyInfo.name,
  "legalName": companyInfo.legalName,
  "description": companyInfo.description,
  "url": companyInfo.url,
  "logo": companyInfo.logo,
  "image": companyInfo.image,
  "foundingDate": companyInfo.foundingDate,
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": companyInfo.contact.phoneInternational,
    "contactType": "customer service",
    "areaServed": companyInfo.areaServed,
    "availableLanguage": "English"
  },
  "address": {
    "@type": "PostalAddress",
    "streetAddress": companyInfo.address.streetAddress,
    "addressLocality": companyInfo.address.addressLocality,
    "addressRegion": companyInfo.address.addressRegion,
    "postalCode": companyInfo.address.postalCode,
    "addressCountry": companyInfo.address.addressCountry
  },
  "sameAs": [
    companyInfo.socialMedia.facebook,
    companyInfo.socialMedia.twitter,
    companyInfo.socialMedia.linkedin,
    companyInfo.socialMedia.instagram
  ]
};

// Local Business Schema
export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": companyInfo.name,
  "description": companyInfo.description,
  "url": companyInfo.url,
  "logo": companyInfo.logo,
  "image": companyInfo.logo,
  "telephone": companyInfo.contact.phoneInternational,
  "email": companyInfo.contact.email,
  "priceRange": companyInfo.priceRange,
  "address": {
    "@type": "PostalAddress",
    "streetAddress": companyInfo.address.streetAddress,
    "addressLocality": companyInfo.address.addressLocality,
    "addressRegion": companyInfo.address.addressRegion,
    "postalCode": companyInfo.address.postalCode,
    "addressCountry": companyInfo.address.addressCountry
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "27.1767",
    "longitude": "78.0081"
  },
  "sameAs": [
    companyInfo.socialMedia.facebook,
    companyInfo.socialMedia.twitter,
    companyInfo.socialMedia.linkedin,
    companyInfo.socialMedia.instagram
  ],
  "openingHours": "Mo-Fr 09:00-18:00",
  "areaServed": {
    "@type": "GeoCircle",
    "geoMidpoint": {
      "@type": "GeoCoordinates",
      "latitude": "27.1767",
      "longitude": "78.0081"
    },
    "geoRadius": "global"
  }
};

// Professional Service Schema
export const professionalServiceSchema = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "name": companyInfo.name,
  "description": companyInfo.description,
  "url": companyInfo.url,
  "logo": companyInfo.logo,
  "telephone": companyInfo.contact.phoneInternational,
  "email": companyInfo.contact.email,
  "priceRange": companyInfo.priceRange,
  "address": {
    "@type": "PostalAddress",
    "streetAddress": companyInfo.address.streetAddress,
    "addressLocality": companyInfo.address.addressLocality,
    "addressRegion": companyInfo.address.addressRegion,
    "postalCode": companyInfo.address.postalCode,
    "addressCountry": companyInfo.address.addressCountry
  },
  "areaServed": companyInfo.areaServed,
  "serviceType": companyInfo.serviceType,
  "sameAs": [
    companyInfo.socialMedia.facebook,
    companyInfo.socialMedia.twitter,
    companyInfo.socialMedia.linkedin,
    companyInfo.socialMedia.instagram
  ]
};
